var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!!_vm.value)?_c('v-alert',{attrs:{"dense":"","outlined":"","color":"info","icon":"mdi-information","border":"left"}},[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Tipp:")]),_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }